import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AuthBootstrap from "./components/feature/AuthBootstrap";
import AiSupportWidget from "./components/ai/AiSupportWidget";
import PageViewTracker from "./components/feature/PageViewTracker";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <PageViewTracker />
        <AuthBootstrap />
        <AppRoutes />
        <AiSupportWidget />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
